import * as Yup from 'yup';

const passwordRules = Yup.string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
  .matches(/[a-z]/, 'Must contain at least one lowercase letter')
  .matches(/[0-9]/, 'Must contain at least one number')
  .matches(/[!@#$%^&*(),.?":{}|<>_\-+=]/, 'Must contain at least one special character')
  .required('Password is required');

export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
});

export const resetPasswordSchema = Yup.object({
  password: passwordRules,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Please confirm your password')
});